import { FE_PREFETCH_PDP_APIS_HOVER_250409 } from "@faire/retailer-settings/FE_PREFETCH_PDP_APIS_HOVER_250409";
import {
    useAssignSetting,
    useSetting,
  } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useSettingPDPPrefetchOnHover = (): IThreeVariantXP.Bucket =>
  useSetting(FE_PREFETCH_PDP_APIS_HOVER_250409);

export const useAssignSettingPDPPrefetchOnHover = () =>
  useAssignSetting(FE_PREFETCH_PDP_APIS_HOVER_250409);
